export const BillingBannerEvents = {
  FAILED_PAYMENT_VIEW_INVOICES_CLICKED:
    "billing/failed-payment-banner-view-invoices-clicked",
  FAILED_PAYMENT_DISMISSED: "billing/failed-payment-banner-dismissed",
  SHOPIFY_BILLING_DEADLINE_VIEW_BILLING_CLICKED:
    "billing/shopify-returns-deadline-banner-view-billing-clicked",
  SHOPIFY_BILLING_DEADLINE_DISMISSED:
    "billing/shopify-returns-deadline-banner-dismissed",
} as const;
